// extracted by css-extract-rspack-plugin
export default {"root":"root-wSyFPo","provider":"provider-QQ14gW","username":"username-Fa_p8f text-base-semibold","email":"email-uw5R8T text-base-regular"};